const STRING = {
    configuracoes: 'Configuración',
    enderecos: 'Direcciones',
    odhen_interface: 'Interfaz de Odhen',
    perifericos_DNS: 'DNS Periféricos',
    porta_balanca: 'Puerta de escala',
    cores: 'Colores',
    primary_color: 'Color primario',
    primary_light: 'Color primario suave',
    primary_dark: 'Color primario oscuro',
    header_color: 'Color del encabezado',
    categorie_color: 'Color de categorías',
    categorie_font_color: 'Color de fuente de las categorías',
    cart_color: 'Color de fondo del carrito',
    cart_font_color: 'Color de fuente del carrito',
    consumidor: 'Consumidor',
    tipo_consumidor: 'Tipo de Consumidor',
    codigo_loja: 'Código de la tienda',
    codigo_filial: 'Código de sucursal',
    dispositivo: 'Dispositivo',
    digitos_NSU: 'Número de Dígitos para NSU (Ej. 13 o 20) vacíos para automático',
    fechamento_automatico: '¿Cierre automático a las 00:00?',
    emitir_fechamento_dia: 'Enviar cierre del día',
    modalidade_entrega: 'Modalidad de entrega',
    drive_throught: 'Drive Throught',
    comer_aqui: 'Comer aquí',
    levar: 'Toma',
    parametrizacao_impressora: 'Parametrización de la impresora',
    modelo: 'Modelo',
    porta_impressora: 'Puerto de impresora',
    testar_impressora: 'Impresora de prueba',
    bematech_Mp_20: 'Bematech Mp-20',
    epson_tm_T88IIP: 'Epson Tm-T88IIP',
    bematech_Mp_2100: 'Bematech Mp-2100',
    bematech_Mp_4000: 'Bematech Mp-4000',
    sewoo_chile: 'Sewoo - Chile',
    IBM_4610_colombia: 'IBM-4610 - Colombia',
    bematech_MP_100_peru: 'Bematech MP-100 - Perú',
    daruma_DR600: 'Daruma DR600',
    epson_TM_U22A: 'Epson TM-U22A',
    daruma_DR700: 'Daruma DR700',
    epson_M244A: 'Epson M244A',
    zebra_Tlp_2844: 'Zebra Tlp 2844',
    bematech_MP_4200: 'Bematech MP-4200',
    epson_TM_T88V: 'Epson TM-T88V',
    epson_TM_T20: 'Epson TM-T20',
    sweda_SI_300S: 'Sweda SI-300S',
    elgin_I9: 'Elgin I9',
    epson_TM_T88IV_ethernet: 'Epson TM-T88IV Ethernet',
    elgin_kiosk_BKT681: 'Elgin Kiosk BKT681',
    bematech_MP_4200_compartilhada: 'Bematech MP-4200 - Compartido',
    custom_TG2480H: 'Custom TG2480H',
    gpos700: 'GPOS700',
    poynt: 'Poynt',
    tectoy_impressora_pequena: 'K2 Mini - Imp P',
    tectoy_impressora_grande: 'K2 Mini - Imp G',
    gerais: 'General',
    modo_TAP: '¿Modo TAP?',
    modo_balanca: '¿Modo de equilibrio del Premio Toledo 3?',
    habilita_agruparnaimpressao: 'Habilitar agrupar en impresión',
    habilita_modo_slim: 'Habilitar modo Slim',
    habilita_leitura_cod: 'Permite la lectura de códigos de barras de productos.',
    habilita_acessibilidade: 'Habilitar modo accesibilidad',
    habilita_modo_edicao: 'Habilitar el modo de edición de color',
    exibir_produtos_sem_foto: '¿Mostrar productos sin foto?',
    exibir_a_partir_de: '¿Mostrar "desde" al lado de los precios?',
    exibe_botao_continuar_comprando: '¿Mostrar el botón "Continuar comprando" en el carrito?',
    cardapio_deve_expirar: '¿El menú debería caducar en 30 minutos?',
    utiliza_pager: '¿Usas buscapersonas?',
    altera_quantidade_adicionais: '¿Puedes cambiar la cantidad de elementos adicionales?',
    imprime_espelho_pedido: '¿Orden de impresión?',
    habilita_subgrupos: '¿Habilitar subgrupos?',
    habilita_observacao_digitada: '¿Habilitar observación escrita?',
    exibe_itens_em_lista: '¿Mostrar elementos promocionales del grupo en la lista?',
    minimiza_grupo_quantidade_maxima: '¿Minimizar el grupo al llegar a la cantidad máxima?',
    taxa_servico_fixa: '¿Usas Tarifa Fija de Servicio?',
    diferenca_preco_minimo: '¿Mostrar diferencia mínima de precio?',
    pagamentos_homologacao: 'Homologación de Pagos? (No activar en producción)',
    imagens_customizaveis: 'Imágenes personalizables (jpg, png)',
    configurar: 'Configurar',
    usuario: 'Usuario',
    senha: 'Contraseña',
    entrar: 'Entrar',
    cancelar: 'Cancelar',
    version: 'Versión',
    confirmar: 'Confirmar',
    itens_pesaveis: 'Artículos pesables',
    cancelamento_TEF: 'Cancelación de TEF',
    NSU: 'NSU',
    nota_fiscal: 'Factura',
    data: 'Fecha',
    valor: 'Valor',
    debito: 'Deuda',
    credito: 'Crédito',
    pix_carteira_digital: 'PIX / Monedero Digital',
    voltar: 'Atras',
    cancelar_TEF: 'Cancelar TEF',
    siga_instrucoes_pinpad: 'Siga las instrucciones en el Pinpad',
    carrinho_vazio: 'Tu carrito está vacío',
    total_caps: 'TOTAL',
    confirmar_pedido: 'Confirmar Pedido',
    reverter: 'Revertir',
    aplicar: 'Aplicar',
    esta_por_ai: '¡Hola! ¿Está por ahí?',
    seu_pedido_te_espera: 'Tu pedido te espera',
    toque_para_voltar_ao_pedido: '¡Toca para volver a tu pedido!',
    para_expirar: 'caducar',
    pedido_para: 'Tu pedido es para:',
    viagem: 'Viaje',
    cadastrar_nova_senha: 'Registrar nueva contraseña',
    repita_a_senha: 'Repetir contraseña',
    aguarde: 'Espera',
    fechar: 'Cerca',
    alguma_observacao: '¿Algún comentario?',
    observacao_livre: 'Observación libre',
    sem_observacao: 'Sin Observación',
    login_consumidor: 'Inicio de sesión del consumidor',
    login_sucesso: 'Inicio de sesión exitoso!',
    total_da_compra: 'Total de Compra:',
    saldo_familia: 'Saldo familiar',
    total_familia: 'Familia total',
    saldo_apos_pagamento: 'Saldo después del pago',
    saldo_cliente: 'Saldo del cliente:',
    recarregar_saldo: 'Recargar Saldo',
    confirmar_pagamento: 'Confirmar pago',
    sim: 'Si',
    nao: 'No',
    enviar_por_e_mail: 'Enviar por Correo electrónico',
    e_mail: 'Correo electrónico',
    bloquear_desbloquear_produtos: 'Bloquear / Desbloquear productos',
    a_partir_de: 'Desde:',
    a_partir_de_gom: 'Desde ',
    recarga_de_saldo: 'Recarga Saldo',
    valor_da_recarga: 'Valor da Recarga',
    CPF: 'CPF',
    familia_de_produtos: 'Família de Productos',
    selecione_forma_pagamento: 'Seleccione el método de pago:',
    personalize_seu_combo: 'Personaliza tu combo:',
    carrinho: 'Carrito',
    comanda: 'Comando:',
    remover: 'Eliminar',
    adicionar_nova_pesagem: 'Agregar nuevo pesaje',
    adicionar_mais_comandas: 'Agregar más comandos',
    total_dois_pontos: 'TOTAL:',
    continuar_comprando: 'Continuar Comprando',
    realizar_pagamento: 'Realizar Pago',
    digite_numero_comanda_ou_faca_leitura: 'Escriba su número de comando o lea el código de barras',
    digite_valor_deseja_pagar: 'Escribe la cantidad que quieres pagar',
    modo_acessibilidade: 'Modo de Accesibilidad',
    digite_numero_comanda: 'Escriba el número de su comando',
    identificacao_de: 'Identificación de ',
    comanda_minusculo: 'comando',
    comanda_maiusculo: 'Comando',
    digitar_com_teclado: 'Escribir con teclado',
    descricao: 'Descripción: ',
    confirmar_edicao: 'Confirmar Edición',
    adicionar_ao_carrinho: 'Agregar al carrito',
    pagamento: 'Pago',
    informar_CPF_na_nota: '¿Quiere informar a CPF/CNPJ en la factura?',
    CNPJ: 'CNPJ',
    nao_informar: 'No Informar',
    CPF_CPNJ: 'CPF / CNPJ',
    todos_campos_obrigatorios: 'Todos los campos son obligatorios',
    data_informada_formato: 'La fecha debe ser informada en formato DDMMAAAA',
    valor_informado_casas_decimais: 'El valor debe ingresarse con un máximo de dos decimales',
    selecione_tipo_cancelamento: 'Seleccione un tipo de reimpresión o cancelamiento',
    atingiu_limite_categoria: 'Ha alcanzado el limite de artículos para esta categoría.',
    escolha: 'Elegir ',
    ate: 'hasta',
    opcao: ' opción',
    opcoes: ' opciones',
    senhas_nao_sao_iguais: 'Las contraseñas ingresadas no son las mismas',
    senha_cadastrada_sucesso: '¡Contraseña registrada con éxito!',
    nao_possivel_criar_nova_senha: 'No fue posible crear una nueva contrasenã para este usuario',
    houve_erro_ao_realizar_login: 'Hubo un error al intentar iniciar sesión',
    erro_editar_consumidor_do_pedido: 'Error al editar el consumidor del pedido',
    preencha_e_mail_corretamente: 'Rellene correctamente el campo de correo electrónico o seleccione otra opción de impresión',
    e_mail_digitado_nao_e_valido: 'El e-mail ingresado no es válido',
    valor_informado_deve_ser_maior_que_zero: 'El valor informado debe ser mayor que cero',
    selecione_familia_produtos: 'Seleccione una familia de productos',
    recarga_realizada_com_sucesso: '¡Tu recarga fue exitosa!',
    operacao_negada_autorizador_tente_novamente: 'Operación denegada por el autorizador. <br><br> Compruebe si la contraseña se has introducido correctamente, si la tarjeta tiene saldo/limite e inténtelo de nuevo',
    operacao_cancelada_operador_tente_novamente: 'Operación denegada por el autorizador. <br><br> Seleccione el método de pago y vuelva a intentarlo',
    nao_possivel_realizar_recarga_valor_estornado: 'No fue posible realizar tu recarga. <br><br> El importe pagado ya ha sido revertido.',
    qual_sabor_deseja: '¿Qué sabor quieres?',
    posso_fazer_sugestao_tamanho: '¿Puedo sugerir tallas?',
    posso_fazer_sugestao_combo: '¿Puedo hacer una sugerencia de combo?',
    leia_o_QR_code: 'Lee el QR Code',
    nao_ha_produto_padrao_pesagem_parametrizado: 'No hay producto estándar para pesaje parametrizado.',
    taxa_de_servico: 'Tarifa de servicio: ',
    nome_dispositivo_obrigatorio: '¡Se requiere el nombre del dispositivo!',
    endereco_interface_obrigatorio: '¡Se requiere la cirección de la Interfaz de Odhen!',
    endereco_perifericos_obrigatorio: '¡La dirección del periférico es obligatoria!',
    preenchimento_das_cores_obrigatorio: '¡El relleno de colores es obligatorio!',
    cores_nao_podem_ser_iguais: 'Los colores no pueden ser iguales',
    parametros_aba_consumidor_faltando: 'Faltan parámetros de la pestaña consumidor',
    precisa_associar_totem_a_um_caixa: 'Necessitas asociar el tótem a un cajero',
    versao_interface: 'Versión de la Interfaz Odhen',
    incompativel_com_o_TAA_necessario_versao: ' incompatible con el TAA. Versión requerida',
    ou_superior: ' o superior',
    tamanho_imagem_menor_que_5MB: 'El tamaño de la imagen debe ser inferior a 5MB',
    interface_nao_encontrada_404: '404 - Interfaz Odhen no encontrada, verifique los archivos de configuración en el servidor.',
    sucesso_interface: 'Interfaz Odhen exitosa </br>',
    senha_invalida: 'Contrasenã no válida',
    realizar_login_outro_usuario: '¿Iniciar sesión como otro usuario?',
    deseja_realizar_logoff_usuario: `¿Está seguro de que desea cerrar la sesión del usuario?`,
    logado_como: 'Iniciado sesión como',
    usuario_logado: 'Usuario conectado',
    escolha_forma_pagamento: 'Elija un método de pago:',
    escolha_forma_pagamento_complementar: 'Elija el método de pago complementario:',
    realize_pagamento_principal: 'Realizar el pago principal elegido:',
    adicionar_taxa_servico: 'Me gustaria agregar la tarifa del servicio por la cantidad de ',
    CPF_CNPJ_invalido: 'CPF/CNPJ no válido.',
    deseja_complementar: '<br><br>¿Quieres complementar ',
    com_outra_forma_pagamento: ' con otro método de pago?',
    voce_precisa_selecionar_algum: 'Necesita seleccionar algunos ',
    terminal_de_auto_atendimento: 'TAA - Terminal de autoservicio',
    deseja_limpar_carrinho: '¿Está seguro de que desea vaciar su carrito?',
    deseja_cancelar_pagamento: '¿Desea cancelar el pago de este pedido?<br><br>Este pedido tiene artículos registrados. Si desea eliminar los artículos, vaya a la caja para realizar la operación.',
    certeza_que_deseja_remover: '¿Está seguro de que desea elimarlo ',
    do_carrinho: ' hacer carrito?',
    cliente_login_nao_e_o_mesmo_comanda: 'El cliente que inició sesión no es el mismo identificado en el comando---',
    foi_excedido_aspas: '" fue superado',
    seu_saldo_familia_de_produtos: 'Tu saldo para la familia de productos "',
    e_insuficiente: '" es insuficiente',
    foi_excedido: ' fue superado',
    saldo_insuficiente_completar_venda: 'Tu saldo es insuficiente para completar esta venta con la cuota de servicio',
    seu_saldo_esta_abaixo_de: 'Tu saldo está por debajo ',
    seu_saldo: 'Tu saldo ',
    da_familia_de_produtos: 'de la familia de productos ',
    das_familias_de_produtos: 'de familias de productos ',
    e: ' es ',
    esta_abaixo_de: ' está debajo ',
    nao_foi_possivel_configurar_pinpad: 'No fue posible configurar el PinPad para iniciar la transacción. Compruebe si los periféricos están funcionando',
    operacao_negada_pelo_autorizador: 'Operación denegada por el autorizador',
    problema_execucao_rotinas_pinpad: 'Problema al ejecutar algunas de las rutinas en el pinpad',
    cancelamento_TEF_finalizado_sucesso: 'Cancelación TEF completada con éxito',
    configuracoes_faltantes_404: '404 - ¡Faltan configuraciones!',
    nao_foi_possivel_receber_XML: 'No fue posible recibir el XML de la factura a través de la Interfaz Odhen',
    nao_foi_possivel_completar_venda: 'No fue posible completar la venta. La cantidad pagada ha sido revertida.',
    nao_possivel_completar_venda: 'No fue posible completar la venta.',
    imagem_tela_de_espera: 'Imagen de la pantalla de espera',
    logo: 'Logo',
    produtos_sem_foto: 'Productos sin foto',
    instrucoes_pager: 'Buscapersonas instrucciones',
    instrucoes_balanca: 'Instrucciones Balanca',
    instrucoes_TAP: 'Instrucciones TAP',
    instrucoes_da_maquininha: 'Instrucciones para la máquina',
    instrucoes_da_impressora: 'Instrucciones de la impresora',
    erro_de_impressora: 'Error de impresora',
    erro_ao_salvar_venda: 'Error al guardar la venta',
    erro_de_pinpad: 'Erro de Pinpad',
    erro_pinpad_2: 'Erro Pinpad 2',
    idiomas: 'Idiomas',
    idiomas_adicionais: 'Idiomas Adicionales',
    idioma_principal: 'Idioma Principal',
    portugues: 'Portugués',
    ingles: 'Inglés',
    espanhol: 'Español',
    cupom_fiscal: '¿Cupón de impuestos?',
    imprimir: 'Imprimir',
    nao_preciso_do_cupom: 'No necesito el cupón',
    importar_exportar_configuracoes: 'Importar/Exportar Configuraciones',
    definir_configuracoes_como_padrao: 'Establecer esta configuración como predeterminada',
    importar_configuracoes_servidor: 'Importar configuración del servidor',
    remover_opcoes_impressao_envio_cupom_fiscal: '¿Quitar opciones de impresión y envío del cupón fiscal?',
    problema_nao_identificado_TEF: 'Hubo un problema no identificado con el TEF',
    pagamento_nao_disponivel_para_este_usuario: 'Este método de pago no está disponible para este usuario. <br><br> Seleccione otro método de pago.',
    nao_foi_possivel_configurar_pinpad_tente_novamente: 'No fue posible configurar el PinPad para iniciar la transacción. Comprueba si el periférico está funcionando <br><br> Cualquier cantidad pagada será reembolsada <br><br> Inténtalo de nuevo',
    problema_execucao_rotinas_pinpad_tente_novamente: 'Problema al ejecutar algunas de las rutinas en el pinpad <br><br> Cualquier cantidad pagada será reembolsada <br><br> Inténtalo de nuevo',
    problema_nao_identificado_TEF_tente_novamente: 'Hubo un problema no identificado con el TEF <br><br> Cualquier cantidad pagada será reembolsada <br><br> Inténtalo de nuevo',
    utiliza_layout_alternativo: '¿Utiliza un diseño alternativo?',
    proximo: 'Próximo',
    endereco_sitef: 'Dirección del Sitef',
    video_nao_permitido: 'El archivo de video solo está permitido en la "Imagen de pantalla de espera"',
    configuracoes_salvas_para_caixa: 'Hay configuraciones guardadas para el cajero',
    importar_configuracoes: '<br> ¿Quieres importar la configuración??',
    deseja_importar_configuracoes_servidor: '¿Desea importar la configuración predeterminada del servidor?',
    deseja_definir_configuracoes_atuais_padrão: '¿Desea establecer la configuración actual de este TAA como predeterminada?',
    configuracoes_importadas_sucesso: '¡La configuración del cajero se ha importado correctamente!',
    falha_importar_config_caixa: 'No se puede importar la configuración del cajero.',
    configuracao_definida_padrao: '¡La configuración de este TAA se ha establecido por defecto!',
    configuracao_padrao_importada: '¡La configuración predeterminada se ha importado correctamente!',
    falha_importar_config_padrao: 'No se puede cargar la configuración del servidor.',
    utiliza_leitor_barras: '¿Lector de código de barras?',
    insira_numero_comanda: 'Introduzca su número de pedido:',
    insira_numero_pager: 'Introduzca el número del pager',
    por_favor_insira_comanda: 'Por favor, introduzca su número de pedido',
    escolha_um_grupo: '¿Que deseas?',
    concluir: 'Concluir',
    limpar: 'Limpiar',
    pesquisar: 'Buscar: ',
    nao_ha_itens: 'No hay elementos almacenados en caché en el TAA. <br> Para utilizar la función "Bloquear/Desbloquear" es necesario haber accedido al menú del producto. Después de cargar los productos, esta función estará disponible.',
    ultimo_fechamento_dia_sucesso: 'El último cierre del día se completó con éxito. <br><br> Este cajero está bloqueado hasta el día siguiente.',
    fechamento_caixa_sucesso: 'El cierre de lo cajero se realizó con éxito.',
    este_e_ultimo_fechamento_dia: '¿Es este el último cierre del día?',
    caixa_bloqueado: 'Ya se ha realizado el último cierre del día para este tótem. <br><br> El cajero está bloqueado.',
    nao_possui_acesso_suficiente: 'No tiene suficiente acceso para completar esta operación.',
    permissoes_nao_cadastradas: 'Los permisos para este usuario no han sido registrados. <br><br> Accede a la pantalla "Control de Acceso TAA móvil" en Retail y regístrate. <br><br> El TAA lee exclusivamente los permisos registrados en esa pantalla.',
    price_font_color: 'Color de fuente del precio',
    preco_em_negrito: 'Habilita fuente de precios en negrita',
    reimpressao_cupom_fiscal: 'Reimpressão/Cancelamento de Cupom Fiscal',
    visualizar: 'Visualización',
    data_dois_pontos: 'Fecha: ',
    verificar_conexao: 'Verifica la conexión',
    verificar_pendencias: 'Verificar Pendientes de Impuesto',
    pendente: 'Pendiente',
    processando: 'Procesando...',
    falha: 'Falla',
    concluido: 'Concluido',
    atualizar_informações_caixa: 'Actualizar información del cajero',
    atualizar_recebimentos: 'Tipos de recibo de actualización',
    atualizar_imagens: 'Actualizar imágenes',
    atualizar_cardapio: 'Actualizar menú',
    aplicar_configuracoes: 'Aplicar configuraciones',
    identificacao: 'Identificación',
    informe_celular: 'Por favor, introduzca su número de móvil:',
    nao_q_informar: 'No quiero informar',
    prox: 'Prox',
    utiliza_layout_gom: 'Usar Diseño Gom',
    informe_cpf: 'Introduzca su CPF',
    informe_cpf_cnpj: 'Introduzca su CPF o CNPJ',
    cancelar_pedido: 'Cancelar orden',
    voltar_cardapio: 'Volver al menú',
    boas_noticias: '¡Buenas noticias!',
    voce_possui: 'Tienes ',
    utiliza_desconto: ' descuento al usar. ¿Quieres utilizar esta compra?',
    desconto_aplicado: '¡El descuento se aplicó correctamente!',
    valor_compra: 'Valor de compra: ',
    desconto: 'Descuento: ',
    total_dois_pontos_simples: 'Total: ',
    agora_nao: 'Ahora no',
    aplicar_desconto: 'Aplicar descuento',
    continuar: 'Continuar',
    erro_valor_compra: '¡El valor ingresado es mayor que el valor total de la compra!',
    erro_valor_desconto: '¡Valor ingresado superior al monto disponible para descuento!',
    compra_concluida: 'Compra completada.',
    aguarde_impressao: '¡Espera a que se imprima el pedido!',
    pedido_impresso: '¡Pedido impreso con éxito!',
    falha_enviar_pedido: 'No se pudo enviar el pedido.',
    pedido: 'Orden ',
    enviado_aguarde: 'enviado. Esperar...',
    aguardando_cupom: 'Esperando recibo de impuestos.',
    falha_cupom: 'No se pudo recibir el recibo de impuestos.',
    cupom_recebido: 'Cupón fiscal recibido correctamente.',
    solicita_cancelamento: 'Solicitando cancelación de número de venta',
    venda: 'En venta',
    sera_cancelada: '¡será cancelado!',
    finalizando_compra: 'Finalizando tu compra. Esperar...',
    imprimindo_cupom: 'Impresión de cupón de impuestos. Esperar...',
    cupom_impresso: '¡Cupón de impuestos impreso!',
    timeOut_inatividade: 'Tiempo de inactividad (segundos)',
    timeOutInModal_inatividade: 'Tiempo de espera durante el modal de inactividad (segundos)',
    keyboard_clear: 'Limpiar',
    keyboard_accept: 'Aceptar',
    posicione_o_codigo: 'Coloque el código',
    de_barras_comanda: 'de barras del pedido',
    no_leitor_abaixo: 'en el lector abajo',
    ou_digite_numero_comanda: 'o ingrese el número de pedido:',
    keyboard_space: 'Espacio',
    confira_seu_pedido: 'Revisa tu pedido',
    interface_sem_conexao: 'Interfaz Odhen sin conexión a la base de datos.',
    voltar_tela_inicial: 'Regresando a la pantalla de inicio ',
    msg_pager: 'Puedes rastrear tu pedido a través de tu teléfono celular, apuntando la cámara al QRCODE al costado.',
    msg_qrcode: 'Este QRCODE también está impreso al final de su cupón fiscal',
    voltar_agora: 'Volver ahora',
    menor_zero: 'El valor ingresado debe ser mayor que 0',
    avanca_grupo_quantidade_maxima: '¿Avança grupo automáticamente ao atingir a cantidad máxima?',
    interface_address: 'Dirección de interfaz',
    imprimir_pedidos_em_fichas: 'Imprimir pedidos en tarjetas',
    demora_aguarde: 'Esto está tardando más de lo esperado. \n Espere por favor.',
    taxa_servico_automatica: 'Aplica tarifa de servicio automáticamente',
    remove_taxa_servico: 'Le permite eliminar la tarifa de servicio en TAP',
    va_ao_caixa: 'Ir al cajero para solicitar el retiro de la tarifa del servicio.',
    apresente_cod_barras: 'Presente el código de barras del producto al lector:',
    apresente_novamente: 'Presente el código de barras al lector para agregar más productos',
    produto_nao_encontrado: 'No se encontró ningún producto para el código de barras ingresado!',
    bar_code_cracha: 'Mostrar el código de la insignia en el lector de código de barras.',
    adicionar_produto: 'Agregar producto',
    alteracoes_desfeitas: 'Todos los cambios realizados en el carrito en esta pantalla se deshacerán. ¿Quieres continuar?',
    produtos_excedidos: 'Algunos productos excedieron la cantidad máxima permitida.',
    alterar_produtos: 'Puedes cambiar los productos aquí o volver al menú.',
    de: 'de',
    voltar_inicio: 'Volver a la pantalla de inicio',
    redirecione_caixa: 'Ir al cajero para realizar el pago.',
    alterar_metodo_cracha: 'Entrar con credencial',
    alterar_metodo_rec: 'Entrar con reconocimiento facial',
    alterar_metodo_senha: 'Entrar con usuario y contraseña',
    saldo_inferior: 'Su saldo no puede ser inferior a ',
    valor_max_mensal_forma_pagamento: 'Tu consumo mensual no puede ser mayor que ',
    valor_max_diario_forma_pagamento: 'Tu consumo diario no puede ser mayor que ',
    valor_max_mensal_familia: 'El valor máximo mensual de la familia de productos "',
    valor_max_diario_familia: 'El límite diario de la familia de productos "',
    erro_comanda_vazia: 'Hubo un error al leer el pedido. Por favor, inténtalo de nuevo o dirígete al cajero para realizar el pago.',
    carrinho_valor_0: 'No es posible pagar un pedido con valor de R$ 0,00, por favor diríjase a la caja.',
    comanda_nao_encontrada: 'El comando no tiene consumo.',
    reenviar: 'Reenviar',
    informe_pin: 'Ingresa el código PIN que te enviamos a tu celular',
    fidelidade_message: 'Ingresa tu número de celular y acumula puntos en nuestro programa de fidelización',
    falha_cupom_fiscal: `Fallo de la impresora. \n \n No se puede reimprimir el comprobante fiscal.`,
    falha_cupom_interface: 'No se puede recibir el comprobante fiscal a través de la Odhen Interface',
    cancelamento_manual: 'No se pueden obtener los datos para la cancelación. Cancele manualmente a través de la pantalla de cancelación de TEF',
    cancelamento_manual_mult_pag: 'Este comprobante tiene más de un pago de TEF. Cancele manualmente a través de la pantalla de cancelación de TEF',
    confirma_cancelamento: '¿Confirmar la cancelación de la venta?',
    cancelamneto_realizado: 'Cancelación exitosa',
    cancelar_venda: 'Cancelar venta',
    verificar_params: 'Verificar parámetros',
    pedido_concluido_erro_impressora_1: '¡Tu pedido ha sido completado!',
    pedido_concluido_erro_impressora_2: 'Sin embargo, hubo un pequeño problema con la impresora.',
    pedido_concluido_erro_impressora_3: 'Para recibir tu comprobante de compra:',
    pedido_concluido_erro_impressora_4: '* Toma una foto de la información que aparece a continuación.',
    pedido_concluido_erro_impressora_5: '* Lleva esa foto al cajero y pídele que imprima tu comprobante.',
    pedido_concluido_erro_impressora_6: 'PIN del pedido:',
    pedido_concluido_erro_impressora_7: 'Número de venta:',
    pedido_concluido_erro_impressora_8: 'Haz clic en cualquier lugar de la pantalla para regresar a la página principal.',
    pedido_concluido_erro_impressora_9: '¡Gracias por tu comprensión!',
    pedido_concluido_erro_impressora_10: 'Número del cupón fiscal:',
    data_pedido: 'Fecha:',
    clique_executar_para_iniciar: 'Haga clic en "Ejecutar" para iniciar las funciones administrativas',
    confirma_reimpressao_tef: '¿Desea reimprimir el cupón fiscal y el comprobante TEF?',
    reimprimir_TEF: 'Reimprimir TEF',
    nao_ha_dados_tef: 'No hay datos del TEF',
    confirma_cancelamento_tef: '¿Confirma cancelación?',
    dados_invalidos: 'Datos inválidos',
    funcoes_sitef: 'Funciones Sitef',
    alterar_cpf_cnpj: 'Cambiar CPF/CNPJ',
    informa_cpf: 'Ingresar CPF/CNPJ',
    veja_mais: '... Ver más',
    editar: 'Editar',
    escolha_pelo_menos: 'Elija al menos',
    observacao: 'observación',
    observacoes: 'observaciones',
    desconto_cashback: 'Descuento',
    faca_leitura_do_codigo_de_barras: 'Por favor, aproxime el lector de código de barras',
    de_cashback_para_a_proxima_compra: 'de cashback para la próxima compra',
    aplicado_no_total_do_pedido: 'aplicado en el total del pedido',
    frete_gratis: 'envío gratis',
    informe_codigo_cupom: 'Ingrese el código del cupón',
    codigo_cupom_invalido: 'Código de cupón inválido',
    selecione_o_cupom: 'Seleccione el cupón',
    ver_regras: 'Ver reglas',
    selecionar: 'Seleccionar',
    quero_ganhar_cashback: 'QUIERO GANAR REEMBOLSO EN EFECTIVO',
    utilizar_cupom: 'USAR CUPÓN',
    tem_um_cupom_utilize_para_garantir_seu_desconto: '¿Tienes un cupón? Utiliza para garantizar tu descuento!',
    ao_comprar_acima_de: 'Al comprar por encima de',
    voce_garante: 'garantizas',
    de_cashback_na_proxima_compra: 'de cashback para utilizar en la próxima compra!',
    voce_informou_seu_telefone_e_ganhara: 'Informaste tu teléfono y ganarás',
    na_proxima_compra: 'en la próxima compra!',
    rapido_facil_e_com_economia_garantida: 'Rápido, fácil y con economía garantizada.',
    pratico_imediato_e_perfeito_para_economizar_mais: 'Práctico, inmediato y perfecto para ahorrar más.',
    informe_seu_telefone_e_ganhe: 'Informe su teléfono y gane',
    desconto_nao_pode_exceder_o_valor_do_pedido: 'El descuento no puede exceder el valor del pedido y fue ajustado automáticamente.',
    valido_ate: 'Válido hasta',
    cupom_de_desconto: 'Cupom de descuento',
    desconto_de: 'Descuento de',
    desconto_de_porcentagem: 'Descuento de',
    cashback_de: 'Cashback de',
    cashback_de_porcentagem: 'Cashback de',
    cep: 'CEP',
    rua: 'Calle',
    numero: 'Número',
    complemento: 'Complemento',
    bairro: 'Barrio',
    cidade: 'Ciudad',
    UF: 'UF',
    confirmar_endereco: 'Confirmar dirección',
    informe_cep: 'Ingrese su código postal',
    campos_obrigatorios: 'Por favor, complete todos los campos obligatorios.',
    cep_invalido: 'CEP inválido. Por favor, verifique el CEP informado.',
    buscando_endereco: 'Buscando dirección...',
    endereco_nao_encontrado: 'Dirección no encontrada para el CEP informado. Por favor, verifique el CEP o complete los datos manualmente.',
    razao_social: 'Razón social',
    nome_fantasia: 'Nombre comercial',
    inscricao_estadual: 'Registro estatal',
    registro_estado: 'Registro estatal',
    numero_obrigatorio: 'El campo número es obligatorio.',
    registro_estado_obrigatorio: 'El campo registro estatal es obligatorio.',
    nome_fantasia_obrigatorio: 'El campo nombre comercial es obligatorio.',
    ultima_transacao_nao_finalizada: 'La última transacción no se completó correctamente y será cancelada automáticamente. Cualquier cantidad pagada será reembolsada. Por favor, repita la transacción.',
    nenhum_produto_encontrado: 'No se encontró ningún producto',
    imprime_cupom_fiscal: '¿Imprime cupón fiscal?',
    fidelity_lpgd: 'Al informar su teléfono, declaro que estoy consentiendo con el uso de este dato para fines de cashback, de conformidad con la LGPD.',
    total_do_pedido: 'Total del pedido:',
    valor_do_desconto: 'Valor del descuento:',
    valor_do_cashback: 'Valor del cashback:',
    total_a_pagar: 'Total a pagar:',
    cashback: 'Cashback:',
    adicionou_um_cupom_de_cashback: 'Usted agregó un cupón y ganará ',
    informe_o_codigo_do_cupom: 'Ingrese el código del cupón',
    informe_seu_telefone: 'Ingrese su número de teléfono',
    utiliza_reconhecimento_facial: 'Utiliza Reconocimiento Facial',
    continuar_como: 'Continuar como',
    nao_e_voce: 'No es usted? Elija una de las opciones a continuación:',
    tentar_novamente: 'Intentar de nuevo',
    tentar_outro_metodo: 'Probar otro método',
    aguardando_reconhecimento: 'Posicione su rostro en la cámara...',
    rosto_nao_detectado: 'Rostro no detectado. Asegúrese de tener buena iluminación y posicionamiento correcto.',
    rosto_nao_reconhecido: 'Rostro no reconocido. Intente nuevamente.',
    reconhecimento_facial_pausado: 'Reconocimiento pausado después de múltiples intentos.',
    falha_reconhecimento_facial: 'Reconocimiento facial falló.',
    aguarde_enquanto_realizamos_o_login: 'Espere mientras realizamos el inicio de sesión...',
    login_realizado_com_sucesso: '¡Inicio de sesión realizado con éxito!',
    aguardando_confirmacao_catraca: 'El torniquete solo se liberará después de la confirmación de la venta.',
    recarregar_saldo_indisponivel: 'Recargar saldo no está disponible',
    como_deseja_ser_chamado: '¿Cómo deseas ser llamado?',
    digite_seu_nome: 'Escribe tu nombre',
    complemento_nao_permitido: 'El valor disponible es insuficiente. No es posible realizar el pago con complemento. Por favor, diríjase al cajero para realizar el pago o seleccione otra forma de pago.',
    cashback_cpf_cnpj: 'Para ganar cashback, es necesario informar un CPF o CNPJ válido.',
    limpar_dados_cashback: 'Limpiar datos de cashback',
    verificando_transacoes_pendentes: 'Verificando transacciones pendientes...',
    finalizando_transacao_pendente: 'Finalizando transacción pendiente...',
    transacao_pendente_nao_encontrada: 'No se encontró ninguna transacción pendiente.',
    erro_ao_verificar_transacoes_pendentes: 'No fue posible verificar las transacciones pendientes.',
    cracha: 'Código del crachá',
    aguardando_impressao_do_cupom: 'Imprimiendo cupón fiscal. <br> <br> Por favor, aguarde...',
    nao_puxe_o_papel_da_impressora: 'No puxe el papel de la impresora, hasta que la impresión se complete.',
    cancelando_comanda_pendente: 'Cancelando comanda pendiente...',
    concluindo_comanda_pendente: 'Concluyendo comanda pendiente...',
    cancelando_venda_pendente: 'Cancelando venta pendiente...',
    concluindo_venda_pendente: 'Concluyendo venta pendiente...',
    ultima_transacao_nao_finalizada_cancelada: 'La última transacción no finalizada fue cancelada. <br><br> Cualquier cantidad pagada será reembolsada. <br><br> Por favor, repita la transacción o diríjase al cajero para realizar el pago.',
    ultima_transacao_nao_finalizada_concluida: 'La última transacción no finalizada fue concluida. Si es necesario, solicite al cajero la reimpresión del cupón fiscal.',
    nao_foi_possivel_confirmar_transacao: 'No fue posible confirmar la transacción.',
    nao_ha_venda_a_ser_finalizada: 'La última transacción no finalizada no se completó correctamente. Cualquier cantidad pagada será reembolsada. Por favor, repita la transacción o diríjase al cajero para realizar el pago.',
    reconhecimento_facial: 'Reconocimiento Facial',
    senha_de_acesso: 'Contraseña de Acceso',
    nao_quero_identificar: 'Continuar sin identificar',
    nao_foi_possivel_realizar_login: 'No fue posible realizar el login.',
    qr_code_catraca: 'QR Code para liberación de torniquete',
    ignore_qrCode: 'Ignorar lectura del QR Code en SK210',
    ocultar_detalhes: 'Ocultar detalles',
    ver_detalhes: 'Ver detalles',
    desconto_dois_pontos: 'Descuento: ',
    subtotal_dois_pontos: 'Subtotal: ',
    cancelar_selecao: '¿Desea cancelar el lançamiento?',
    produto_obrigatorio: 'Producto obligatorio',
    remove_produto_sugestao_automatico: 'Remover producto redundante de la sugestión?',
    utiliza_login_inicio: 'Utiliza login en la pantalla de inicio?',
    sinaliza_desconto: 'Sinaliza con un taxado el precio antiguo al lado del nuevo precio con descuento.',
    nao_obrigado: 'No gracias',
    finalizar: 'Finalizar',
    avancar: 'Avanzar',
    combina_com_seu_pedido: 'Combina con su pedido',
    adicionar: 'Agregar',
    powered_by: 'INNOVACIÓN Y TECNOLOGÍA PARA FOODSERVICE',
    valor_complemento: 'Valor del complemento: ',
    exibe_saldo_consumidor_sem_controle: 'Exibe saldo del consumidor que no controla saldo',
    comanda_nao_encontrada_abrir_nova: 'Esta comanda no tiene consumo registrado. ¿Desea incluir un nuevo producto? <br> <br> <b>La comanda se abrirá automáticamente.</b>',
    ao_adicionar_produtos_nao_sera_possivel_separar_as_comandas: 'Al agregar productos no será posible separar las comandas.<br> <br> <b>¿Desea continuar?</b>',
    clarity_project_id: 'ID del proyecto de Microsoft Clarity',
    remove_imprimir_cupom: 'Eliminar la opción de imprimir un recibo de compra.',
    sem_imprimir_comprovante_e_pedido: '¿Permite completar la venta sin imprimir un recibo o pedido?'
}

const getString = function (key) {
    if (!STRING[key]) {
        return key
    }
    return STRING[key]
}

export default {
    getString: getString
}



// WEBPACK FOOTER //
// ./src/assets/lang/es.js